import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Application } from "@verity/proctoring-option/types";
import apiClient from "../../../helpers/api-client";

export type ApplicationType = "Browser" | "Communication" | "Screen Sharing" | "Other";

export type ApplicationApiResponse = {
	id: number;
	name: string;
	processName: string[];
	iconSvg: string;
	type: ApplicationType;
	createdAt: string;
	updatedAt: string;
};

const applicationApi = createApi({
	reducerPath: "application",
	baseQuery: async (arg, api, extraOptions) =>
		fetchBaseQuery({
			fetchFn: apiClient.fetch.bind(apiClient),
			baseUrl: "/api/verity/applications",
		})(arg, api, extraOptions),
	tagTypes: ["Application"],
	endpoints: (builder) => ({
		getAllApplications: builder.query<ApplicationApiResponse[], void>({
			query: () => "/all",
			providesTags: (result) =>
				result ? [...result.map(({ id }) => ({ type: "Application" as const, id })), "Application"] : ["Application"],
		}),
		createApplication: builder.mutation<ApplicationApiResponse, Omit<Application, "id">>({
			query: (application) => ({
				url: "/",
				method: "POST",
				body: { ...application },
			}),
			invalidatesTags: ["Application"],
		}),
		updateApplication: builder.mutation<
			ApplicationApiResponse,
			Omit<Partial<Application>, "id"> & Pick<Application, "id">
		>({
			query: (application) => ({
				url: `/${application.id}`,
				method: "PATCH",
				body: { ...application, id: undefined },
			}),
			invalidatesTags: ["Application"],
		}),
		deleteApplication: builder.mutation<void, number>({
			query: (id) => ({
				url: `/${id}`,
				method: "DELETE",
				responseHandler: "text",
			}),
			invalidatesTags: ["Application"],
		}),
	}),
});

export default applicationApi;
